import * as monaco from 'monaco-editor';

export type GlobalMonacoEditor = monaco.editor.IStandaloneCodeEditor;
declare global {
	interface Window {
		testSuiteMonacoEditor: GlobalMonacoEditor | undefined;
	}
}

interface AddHotkeysOptions {
	monacoEditor: monaco.editor.IStandaloneCodeEditor;
	readonly: boolean;
	callbacks: {
		togglePanelToFullScreen: () => void;
		saveParam?: () => void;
		saveParamAndScene?: () => void;
	};
}

export function monacoEditorAddHotkeys(options: AddHotkeysOptions) {
	const {monacoEditor, readonly, callbacks} = options;

	monacoEditor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyB, callbacks.togglePanelToFullScreen);

	if (!readonly) {
		if (callbacks.saveParam) {
			monacoEditor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter, callbacks.saveParam);
		}
		if (callbacks.saveParamAndScene) {
			monacoEditor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, callbacks.saveParamAndScene);
		}
	}
}
